import { createFileRoute } from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {PERMISSIONS} from "@/lib/auth/roles";
import FirmTools from "@/modules/reputational-tools/firm/firm-tools";
import {TOOLS_FIRM_PATH, TOOLS_FIRM_URL} from "@/utils/urls";

export const Route = createFileRoute(TOOLS_FIRM_PATH)({
  component: RouteComponent,
  beforeLoad: () => {
    return {
      breadcrumbs: [
        { label: 'Reputation', path: '#' },
        { label: 'Firm Marketing tools', path: TOOLS_FIRM_URL },
      ],
    }
  }
})

function RouteComponent() {
  return (
    <div className={'flex flex-col items-center justify-center'}>
      <Authorisation
        roles={[]}
        permissions={[PERMISSIONS.IS_FIRM_VIEW_ON_FIRM_OR_NETWORK, PERMISSIONS.CAN_ACCESS_FIRM_MARKETING_TOOLS_PAGE]}
        forbiddenFallback={<Unauthorized/>}
      >
        <FirmTools />
      </Authorisation>
    </div>
  )
}
